import React from "react";
import GrandLoanListTable from "./components/GrandLoanListTable";
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const GrandLoanList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Grant Loan List</HeadingOne>
          <AddItemBtn url="add-grand-loan" title="Grant Loan" />
        </>
      }
    >
      <div className="col-12">
        <GrandLoanListTable />
      </div>
    </PageBody>
  );
};

export default GrandLoanList;
